/**
 * ISO date (YYYY-MM-DD) `days` from today. Used to prefill a keg's
 * expiration date from the product's default_expiration_days.
 */
export function isoDateInDays(days: number): string {
  const d = new Date()
  d.setDate(d.getDate() + days)
  return d.toISOString().split("T")[0]
}
